// function getSectionH_totalGc(pdf, data) {
//   let h = 0;
//   pdf.setFontSize(12);
//   h += 19; // Section title

//   if (data.length === 0) {
//     h += 16;
//   } else {
//     data.forEach(gc => {
//       if (!gc.isDeleted) h += getSectionH_gcRow(pdf, gc);
//     });
//   }
//   pdf.setFont("helvetica", "normal");

//   console.log("sectionH_gc=", h);
//   return h;
// }

function getSectionH_gcRowHeader(pdf, gc) {
  let h = 0;

  pdf.setFont("times", "normal").setFontSize(10);
  if (!gc) {
    h += 16;
  } else {
    const kwString = gc.keywordsForPrint.map((kw) => "[" + kw + "]").join(", ");
    const splitKwString = pdf.splitTextToSize(kwString, 500);
    const splitNarrative = pdf.splitTextToSize(gc.narrative, 500);
    h += splitKwString.length * 11;
    if (splitNarrative.length > 1) h += 22;
    // Add extra row for "(continued...)"
    else h += 11; // Otherwise, add 1 row (even for blank comment)
  }
  h += 6; // Bottom margin - added b/c this func is only used for determining overflow
  pdf.setFont("helvetica", "normal"); // Reset font
  return h;
}

// Attachments come at the end of gcRow, like a footer
function getSectionH_gcRowAttach(pdf, gc) {
  let h = 0;
  if (gc.attachments.length > 0) {
    const splitAttachmentStr = pdf
      .setFont("helvetica", "normal")
      .setFontSize(10)
      .splitTextToSize(gc.attachments.join("; "), 500);
    h += splitAttachmentStr.length * 11;
  }
  h += 6; // Bottom margin - added b/c this is the end of gcRow
  return h;
}

// function getSectionH_gcRow(pdf, gc) {
//   let h = 0;
//   const splitNarrative = pdf
//     .setFont("times", "normal")
//     .setFontSize(10)
//     .splitTextToSize(gc.narrative, 500);
//   const kwString = gc.keywordsForPrint.map(kw => "[" + kw + "]").join(", ");
//   const splitKwString = pdf.splitTextToSize(kwString, 500);
//   h += 11; // Subject
//   h += splitKwString.length * 11;
//   h += splitNarrative.length * 11;
//   if (gc.attachments.length > 0) {
//     const splitAttachmentStr = pdf
//       .setFont("helvetica", "normal")
//       .setFontSize(10)
//       .splitTextToSize(gc.attachments.join("; "), 500);
//     h += splitAttachmentStr.length * 11;
//   }
//   h += 6;

//   console.log("sectionH_gcRow=", h);
//   return h;
// }

export default function renderAdrGenCommentsV3(data) {
  return function (pdf) {
    let cursorY = this.cursorY;

    // Overflow to next page if TITLE + 1st comment header > rem. H
    // Signature needs 30 before this.maxY
    const gcForRowHeader = data && data.length > 0 ? data[0] : null;
    if (cursorY + 19 + getSectionH_gcRowHeader(pdf, gcForRowHeader) > this.maxY - 30) {
      this._addPage(pdf);
      cursorY = this.cursorY;
    }

    // console.log("cursorY @ top of GC = ", cursorY);

    pdf.setFont("helvetica", "bold").setFontSize(12);
    pdf.line(15, cursorY, 590, cursorY);
    cursorY += 2;
    pdf.line(15, cursorY, 590, cursorY);
    cursorY += 13;
    pdf.text("General Comments", 302, cursorY, {
      align: "center",
    });
    cursorY += 4;
    pdf.line(15, cursorY, 590, cursorY);

    if (data.length === 0) {
      cursorY += 11;
      pdf.setFont("helvetica", "normal").setFontSize(10).text("(None)", 18, cursorY);
      cursorY += 4;
      pdf.line(15, cursorY, 590, cursorY);
    } else {
      data.forEach((gc) => {
        // Page overflow if:
        // remaining H < [(subjectH = 11) + (kwH = 11*splitKw) + (1st comment line = 11))

        // If comment row H exceeds available H, push to new page
        if (cursorY + getSectionH_gcRowHeader(pdf, gc) > this.maxY - 30) {
          this._addPage(pdf);
          cursorY = this.cursorY;
          pdf.setFont("helvetica", "bold").setFontSize(12);
          cursorY += 15;
          pdf.text("General Comments (Continued)", 288, cursorY, {
            align: "center",
          });
          cursorY += 4;
          pdf.line(15, cursorY, 590, cursorY);
        }

        const splitNarrative = pdf
          .setFont("times", "normal")
          .setFontSize(10)
          .splitTextToSize(gc.narrative, 500);
        const kwString = gc.keywordsForPrint.map((kw) => "[" + kw + "]").join(", ");
        const splitKwString = pdf.splitTextToSize(kwString, 500);

        pdf.setFont("Helvetica", "normal");
        cursorY += 11;

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Subject
        ///////////////////////////////////////////////////////////////////////////////////////////
        pdf.setFont("helvetica", "bold").setFontSize(10).text("Subject:", 18, cursorY);
        pdf.setFont("times", "bold").text(gc.subject, 85, cursorY);
        cursorY += 11;

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Keywords
        ///////////////////////////////////////////////////////////////////////////////////////////
        pdf.setFont("helvetica", "bold").text("Keywords:", 18, cursorY);
        pdf.setFont("times", "normal");
        splitKwString.forEach((l, index) => {
          pdf.text(l, 85, cursorY);
          if (index !== splitKwString.length - 1) cursorY += 11;
        });
        cursorY += 11;

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Comment Narrative
        ///////////////////////////////////////////////////////////////////////////////////////////
        pdf.setFont("helvetica", "bold").text("Comments:", 18, cursorY);
        pdf.setFont("times", "normal");
        splitNarrative.forEach((l, index) => {
          pdf.text(l, 85, cursorY);
          if (index < splitNarrative.length) {
            // Determine the need for overflow if current line is 2nd from last
            // in splitNarrative.
            // Bottom margin is 24 if current line is 2nd from last in splitNarrative.
            // Attachment H is 6 if no attachments OR current l is not the last in
            // splitNarrative, and attachCount*12+6 if attachments.
            const botMargin = index === splitNarrative.length - 2 ? 24 : 30;
            const attachH =
              index === splitNarrative.length - 2 ? getSectionH_gcRowAttach(pdf, gc) : 0;
            pdf.setFont("times", "normal");

            // If content fits in remaining H...
            if (cursorY + botMargin + attachH < this.maxY - 30) cursorY += 11;
            else if (index < splitNarrative.length - 1) {
              // If content doesn't fit, and current line is not the last on page,
              // overflow to new page.
              cursorY += 11;
              pdf
                .setFont("times", "italic")
                .text("(continued...)", 85, cursorY)
                .setFont("times", "normal");
              this._addPage(pdf);
              cursorY = this.cursorY;
              pdf.setFont("helvetica", "bold").setFontSize(12);
              cursorY += 15;
              pdf.text("General Comments (Continued)", 288, cursorY, {
                align: "center",
              });
              cursorY += 4;
              pdf.line(15, cursorY, 590, cursorY);
              cursorY += 12;
              pdf.setFont("times", "normal").setFontSize(10);
            }
          }
        });

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Comment Attachments
        ///////////////////////////////////////////////////////////////////////////////////////////
        pdf.setFont("helvetica", "normal");
        if (gc.attachments.length > 0) {
          const splitAttachmentStr = pdf
            .setFont("helvetica", "normal")
            .setFontSize(10)
            .splitTextToSize(gc.attachments.join("; "), 500);
          cursorY += 11;
          pdf
            .setFont("helvetica", "bold")
            .text("Attachments:", 18, cursorY)
            .setFont("helvetica", "normal");
          splitAttachmentStr.forEach((l, index) => {
            pdf.text(l, 85, cursorY);
            if (index < splitAttachmentStr.length - 1) cursorY += 11;
          });
          console.log("cursorY=", cursorY);
        }
        cursorY += 6;

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Separator Line
        ///////////////////////////////////////////////////////////////////////////////////////////
        pdf.line(15, cursorY, 590, cursorY);
      });
    }

    // console.log("cursorY @ bottom of GC = ", cursorY);

    this._renderSignature(pdf);

    this._setDefaults(pdf);
    this.cursorY = cursorY;
  };
}
